import { getParam } from '../utils/mockUtils'
const stroage = window.localStorage
const ROLE = {
  ITEM: 'ITEM', // 项目管理
  PRODUCT: 'PRODUCT', // 产品线
  AGENT: 'AGENT' // 代理商
}

function getUserMessage(options) {
  const projectId = getParam(options.url, 'projectId')
  const role = stroage.getItem('role')
  const menus = getMenus(role, { projectId })
  const data = {
    createTime: 1575603097649,
    describe: null,
    email: null,
    hasDefault: false,
    hasFirstTimeLoggedIn: false,
    hasSuperPrivilege: true,
    menus: menus,
    id: '5fdf3a9e-8a27-483b-b42a-ebfb0ed2c766',
    realName: 'admin',
    userName: 'admin'
  }
  // return DataResult.getSuccessResponse(data);
  return {
    status: 'SUCCESS',
    content: {
      id: '123456',
      username: '17600861234',
      password: '',
      realName: '张三',
      email: '',
      userType: 'admin',
      orgType: 'customer',
      organizationId: '1212121212',
      organizationName: '学校',
      area: '1, 11'
    },
    message: 'sjdlskdjlksdj',
    msgArgArr: null,
    msgKey: null
  }
}

function getMenus(role, options) {
  const { projectId } = options
  // 如果有项目Id，返回的项目管理的菜单
  if (projectId) {
    return getMenuByRole(ROLE.ITEM)
  }
  return getMenuByRole(role)
}

function getMenuByRole(role) {
  switch (role) {
    case 'AGENT':
      return ['dashboard', 'projectManage', 'organizationManage', 'feedBack']
    case 'ITEM':
      return ['summary', 'idvTerminal', 'behaviorLog', 'setting', 'feedBack']
    case 'PRODUCT':
      return ['dashboard', 'projectManage', 'cloudTeamManage', 'feedBack']
    default:
      return ['welcome']
  }
}



export default {
  getUserMessage
}
